import Skeleton from '@ingka/skeleton'
import SSRIcon from '@ingka/ssr-icon'
import arrowRight from '@ingka/ssr-icon/paths/arrow-right'

import styles from './start-gallery.module.css'

const arr = new Array(15).fill(0)
export function StartGallerySkeleton() {
  return (
    <>
      {arr.map((_, i) => (
        <li aria-busy className={styles.skeletonCard} key={`skeleton-${i.toString()}`}>
          <Skeleton width="70%" />
          <Skeleton height="200px" width="100%" />
          <Skeleton width="40%" />
          <Skeleton width="45%" />
          <Skeleton width="40%" />
          <Skeleton width="45%" />
          <div className={styles.iconContainer}>
            <SSRIcon paths={arrowRight} />
          </div>
        </li>
      ))}
    </>
  )
}
